import { confirmUserAttribute, updateUserAttributes } from "@aws-amplify/auth";
import React, { useState } from "react";
import EditUserForm from "./user_portal/EditUserForm";
import VerificationCode from "./user_portal/VerificationCode";

function ManageUserProfile({ goBack, userAttributes, refreshUserAttributes }) {
    // 0 = Form, 1 = Confirm Code
    const [stage, setStage] = useState(0);

    const handleBackButton = () => {
        setStage(0);
        goBack();
    }

    const handleUpdateAttributes = async ({ email, preferred_username, given_name }) => {
        const { email: { nextStep: { updateAttributeStep } } } = await updateUserAttributes({
            userAttributes: {
                given_name,
                preferred_username,
                email,
            }
        });

        await handleEmailNextStep(updateAttributeStep);
    };

    const handleEmailNextStep = async (nextStep) => {
        refreshUserAttributes();

        if (nextStep !== "CONFIRM_ATTRIBUTE_WITH_CODE") {
            goBack();
            return;
        }

        setStage(1);
    }

    const handleVerifyAttributes = (confirmationCode) => {
        const resp = confirmUserAttribute({
            userAttributeKey: "email",
            confirmationCode
        });
        resp.then(() => setStage(0)).then(() => refreshUserAttributes()).catch(() => {
        });

        return resp;
    }

    if (stage === 0) {
        return (
            <EditUserForm currentUserAttributes={userAttributes} handleSubmit={handleUpdateAttributes}
                          handleBack={handleBackButton}/>
        );
    }

    return (
        <VerificationCode handleSubmit={handleVerifyAttributes}/>
    );
}

export default ManageUserProfile;